module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "error404"
  }, [_c('img', {
    staticClass: "ot2_animation",
    attrs: {
      "src": require("../assets/img/ot2-animation.gif")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h2', [_vm._v("Sorry!")]), _vm._v(" "), _c('span', [_vm._v("Protocol not found.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f12b3ebe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error404Page.vue
// module id = 167
// module chunks = 2